export class UploadFile {
  addedByName: string;
  date: string;
  fileName: string;
  contentType: string;

  constructor(addedByName?: string, date?: string, fileName?: string, contentType?: string) {
    this.addedByName = addedByName;
    this.date = date;
    this.fileName = fileName;
    this.contentType = contentType;
  }
}
